import React, { useState, useEffect } from 'react';
import './Hero.css';

const Hero = () => {
    const [currentSlide, setCurrentSlide] = useState(0);

    const slides = [
        {
            image: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=1600&h=900&fit=crop',
            headline: 'Your All-In-One Supply Partner',
            subheadline: 'Quality products and services, all under one roof.'
        },
        {
            image: 'https://images.unsplash.com/photo-1578575437130-527eed3abbec?w=1600&h=900&fit=crop',
            headline: 'Premium Products, Trusted Sources',
            subheadline: 'Reliably sourced essentials across every category.'
        },
        {
            image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=1600&h=900&fit=crop',
            headline: 'Elevate Every Environment',
            subheadline: 'Everything your business needs to operate at its best.'
        },
    ];

    const totalSlides = slides.length;

    const goToSlide = (index) => {
        setCurrentSlide((index + totalSlides) % totalSlides);
    };

    const nextSlide = () => {
        goToSlide(currentSlide + 1);
    };

    const prevSlide = () => {
        goToSlide(currentSlide - 1);
    };

    useEffect(() => {
        const interval = setInterval(() => {
            nextSlide();
        }, 5000);

        return () => clearInterval(interval);
    }, [currentSlide]);

    return (
        <section className="hero" id="home">
            <div className="carousel">
                <div 
                    className="carousel-track" 
                    style={{ transform: `translateX(-${currentSlide * 100}%)` }}
                >
                    {slides.map((slide, index) => (
                        <div key={index} className="carousel-slide">
                            <img 
                                src={slide.image} 
                                alt={slide.headline} 
                                className="carousel-image" 
                            />
                            <div className="carousel-overlay">
                                <div className="carousel-text">
                                    <h1 className="carousel-headline">{slide.headline}</h1>
                                    <p className="carousel-subheadline">{slide.subheadline}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                <button 
                    className="carousel-arrow carousel-arrow-left" 
                    onClick={prevSlide}
                    aria-label="Previous slide"
                >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <polyline points="15 18 9 12 15 6"/>
                    </svg>
                </button>

                <button 
                    className="carousel-arrow carousel-arrow-right" 
                    onClick={nextSlide}
                    aria-label="Next slide"
                >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <polyline points="9 18 15 12 9 6"/>
                    </svg>
                </button>

                <div className="carousel-controls">
                    {slides.map((_, index) => (
                        <button
                            key={index}
                            className={`carousel-dot ${index === currentSlide ? 'active' : ''}`}
                            onClick={() => goToSlide(index)}
                            aria-label={`Go to slide ${index + 1}`}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Hero;
